import sk from "../lang/sk/sk.json"
import cz from "../lang/cz/cz.json"
import en from "../lang/en/en.json"
import de from "../lang/de/de.json"
import hu from "../lang/hu/hu.json"

//export default { sk, cz, en, de, hu };
export default { sk, cz, en};